import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './sub_header.module.scss';
import { Row } from '../grid/Grid';

type Props = {
  classNames?: string;
  id?: string;
};

export const SubHeader: FC<Props> = ({
  children,
  classNames = '',
  id = '',
}) => {
  return (
    <Row
      className={classnames(styles.container, classNames)}
      id={id}
      data-test-id="subheader-container"
    >
      {children}
    </Row>
  );
};
